import React, { Component } from 'react';
import { connect } from "react-redux";
import ReportsSidebar from "./ReportsSidebar";
import { useParams} from "react-router-dom";
import GeneralReport from "./sub/GeneralReport";
import HourlyReport from "./sub/HourlyReport";
import Loading from "../Loading";



@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class Reports extends Component {

    constructor(props) {
        super(props);

		this.state = {
            loadingReports: false
        }

    }

    componentDidMount() {
        this.props.dispatch({
            type: 'SET_MENU',
            data: "reports"
        });
    }

    render() {

        if (this.state.loadingReports == true) {
            return (<React.Fragment><Loading/></React.Fragment>);
        }
        return (
            <React.Fragment>
                <ReportsSidebar />

                <div className="settings-center-div">
                        <React.Fragment>
                            {typeof this.props.match.params.link == "undefined" &&
                            <GeneralReport />
                            }
							
							{this.props.match.params.link == "general" &&
                            <GeneralReport />
                            }
							
							{this.props.match.params.link == "hourly" &&
                            <HourlyReport />
                            }
                        </React.Fragment>
                </div>


            </React.Fragment>
        );
    }
}

export function withRouter(Children){
    return(props)=>{

        const match  = {params: useParams()};
        return <Children {...props}  match = {match}/>
    }
}
export default withRouter(Reports, { withRef: true });
